import React, { createContext } from 'react'
import useAuthContext from './actions/authContext'
import { useEffect } from 'react'
import { useState } from 'react'
import { getSubdivisions, getUsers, getUsersAdmin } from 'requests/auth'

export const RootStoreContext = createContext(null)

const RootStore = ({ children }) => {
  const AuthContext = useAuthContext()

  const [usersAdmin, setUsersAdmin] = useState([])
  const [users, setUsers] = useState([])
  const [subdivisionDict, setSubdivisionsDict] = useState([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const userDataAdmin = await getUsersAdmin()
      const usersList=await getUsers()
      const subdivisions=await getSubdivisions()
      setUsersAdmin(userDataAdmin)
      setUsers(usersList?.userList)
      setSubdivisionsDict(subdivisions.data)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <RootStoreContext.Provider
      value={{
        authStore: AuthContext,
        usersAdmin,
        users,
        subdivisionDict
      }}
    >
      {children}
    </RootStoreContext.Provider>
  )
}

export default RootStore
